import React, { useState } from 'react';
import { ShoppingCartIcon, UserIcon, SearchIcon, MenuIcon, XIcon } from 'lucide-react';
import { Link, NavLink } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import { SearchModal } from './SearchModal';
import { motion, AnimatePresence } from 'framer-motion';
export function Navbar() {
  const {
    cartCount
  } = useCart();
  const [searchOpen, setSearchOpen] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const navLinkClasses = ({
    isActive
  }: {
    isActive: boolean;
  }) => `text-sm font-bold uppercase tracking-wide transition-colors ${isActive ? 'text-clinical-blue border-b-2 border-clinical-blue pb-1' : 'text-slate-900 hover:text-clinical-blue'}`;
  const mobileNavLinkClasses = ({
    isActive
  }: {
    isActive: boolean;
  }) => `block text-base font-bold uppercase tracking-wide transition-colors py-3 ${isActive ? 'text-clinical-blue' : 'text-slate-900 hover:text-clinical-blue'}`;
  return <nav className="w-full bg-white border-b border-slate-100" data-id="element-160">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-161">
        <div className="flex justify-between h-20 sm:h-24 items-center" data-id="element-162">
          <Link to="/" className="flex-shrink-0" onClick={() => setMobileMenuOpen(false)} data-id="element-163">
            <span className="text-lg sm:text-2xl font-black tracking-tight text-clinical-blue uppercase" data-id="element-164">
              Daily Care Pharmacy
            </span>
          </Link>

          <div className="hidden lg:flex items-center space-x-10" data-id="element-165">
            <NavLink to="/prescriptions" className={navLinkClasses} data-id="element-166">
              Prescriptions
            </NavLink>
            <NavLink to="/otc-products" className={navLinkClasses} data-id="element-167">
              OTC Products
            </NavLink>
            <NavLink to="/services" className={navLinkClasses} data-id="element-168">
              Services
            </NavLink>
            <NavLink to="/locations" className={navLinkClasses} data-id="element-169">
              Locations
            </NavLink>
          </div>

          <div className="flex items-center space-x-2 sm:space-x-5" data-id="element-170">
            <button onClick={() => setSearchOpen(true)} className="p-2 text-slate-400 hover:text-clinical-blue transition-colors" data-id="element-171">
              <SearchIcon className="w-5 h-5" data-id="element-172" />
            </button>
            <Link to="/cart" className="p-2 text-slate-400 hover:text-clinical-blue transition-colors relative" data-id="element-173">
              <ShoppingCartIcon className="w-5 h-5" data-id="element-174" />
              {cartCount > 0 && <span className="absolute top-1 right-1 w-4 h-4 bg-clinical-blue text-white text-[10px] font-bold rounded-full flex items-center justify-center" data-id="element-175">
                  {cartCount}
                </span>}
            </Link>
            <button className="lg:hidden p-2 text-slate-400 hover:text-clinical-blue transition-colors" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} data-id="element-176">
              {mobileMenuOpen ? <XIcon className="w-6 h-6" data-id="element-177" /> : <MenuIcon className="w-6 h-6" data-id="element-178" />}
            </button>
          </div>
        </div>
      </div>

      <AnimatePresence data-id="element-179">
        {mobileMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="lg:hidden border-t border-slate-100 bg-white overflow-hidden" data-id="element-180">
            <div className="px-4 py-6 space-y-4" data-id="element-181">
              <NavLink to="/prescriptions" className={mobileNavLinkClasses} onClick={() => setMobileMenuOpen(false)} data-id="element-182">
                Prescriptions
              </NavLink>
              <NavLink to="/otc-products" className={mobileNavLinkClasses} onClick={() => setMobileMenuOpen(false)} data-id="element-183">
                OTC Products
              </NavLink>
              <NavLink to="/services" className={mobileNavLinkClasses} onClick={() => setMobileMenuOpen(false)} data-id="element-184">
                Services
              </NavLink>
              <NavLink to="/locations" className={mobileNavLinkClasses} onClick={() => setMobileMenuOpen(false)} data-id="element-185">
                Locations
              </NavLink>
              <div className="pt-4 border-t border-slate-100" data-id="element-186">
                <button className="flex items-center gap-3 text-slate-500 hover:text-clinical-blue font-bold uppercase tracking-wide text-sm py-2" data-id="element-187">
                  <UserIcon className="w-5 h-5" data-id="element-188" /> Sign In / Register
                </button>
              </div>
            </div>
          </motion.div>}
      </AnimatePresence>

      <SearchModal isOpen={searchOpen} onClose={() => setSearchOpen(false)} data-id="element-189" />
    </nav>;
}